import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const testimonials = [
  {
    nameKey:    'testimonials.t1.name',
    roleKey:    'testimonials.t1.role',
    quoteKey:   'testimonials.t1.quote',
    initials:   'PT',
    color:      'from-sky-500 to-blue-600',
  },
  {
    nameKey:    'testimonials.t2.name',
    roleKey:    'testimonials.t2.role',
    quoteKey:   'testimonials.t2.quote',
    initials:   'MF',
    color:      'from-violet-500 to-purple-600',
  },
  {
    nameKey:    'testimonials.t3.name',
    roleKey:    'testimonials.t3.role',
    quoteKey:   'testimonials.t3.quote',
    initials:   'LR',
    color:      'from-emerald-500 to-teal-600',
  },
];

export function TestimonialsSection() {
  const { t } = useLanguage();

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-primary/10 text-primary font-semibold text-sm px-4 py-1.5 rounded-full uppercase tracking-wide mb-4">
            {t('testimonials.badge')}
          </span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('testimonials.title')}</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">{t('testimonials.subtitle')}</p>
        </div>

        {/* Cards */}
        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((t2, i) => (
            <div key={i} className="bg-gray-50 border border-gray-100 rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col">

              {/* Quote mark */}
              <div className="text-5xl text-primary/20 font-serif leading-none mb-4">"</div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed flex-1 mb-6 italic">
                {t(t2.quoteKey)}
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 border-t border-gray-200 pt-5">
                <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${t2.color} flex items-center justify-center text-white font-bold text-sm flex-shrink-0`}>
                  {t2.initials}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm">{t(t2.nameKey)}</p>
                  <p className="text-gray-500 text-xs">{t(t2.roleKey)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
